export const Spinner = () => {
  return <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-t-2 border-current" />;
};
